// Generated by CoffeeScript 2.7.0
var Bridge;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import UserBoundary from 'trunks/vue/admin/components/user_boundary.js';

export default Bridge = {newAlertify, newConfirm, UserBoundary};
